<op-date-picker-adapter
  [required]="to.required"
  [disabled]="to.disabled"
  [formControl]="formControl"
  [formlyAttributes]="field"
></op-date-picker-adapter>